import { FormInstance } from 'antd/lib'
import {
  GroupManagementForm,
  GroupManagementFormFieldTypes,
} from './group-management-form.tsx'
import { useTranslation } from 'react-i18next'
import IdeyaModal from '../../../../common/antd/ideya-modal.tsx'

interface ActionGroupModalProps {
  showActionModal: boolean
  handleCloseModal: () => void
  form: FormInstance<GroupManagementFormFieldTypes>
}

export const ActionGroupModal: React.FC<ActionGroupModalProps> = ({
  showActionModal,
  handleCloseModal,
  form,
}) => {
  const { t } = useTranslation()

  const handleCloseAndClear = () => {
    handleCloseModal()
    form.resetFields()
  }

  return (
    <IdeyaModal
      open={showActionModal}
      title={t('firm_management.group_modal.add_group')}
      destroyOnClose
      isForm={true}
      onCancel={handleCloseAndClear}
    >
      <GroupManagementForm onCancel={handleCloseModal} form={form} />
    </IdeyaModal>
  )
}
